import { useSnackbar } from "notistack";
import { GameGiveRatingUseCase } from "../../../../domain/usecase/game/giveRating/GiveRatingUseCase";
import { showGlobalLoadingView } from "../../../../core/utils/Utils";
import { State } from "../../../../domain/model/ResponseState";
import { useState } from "react";

export function GameFinishedViewModel(
  gameGiveRatingUseCase: GameGiveRatingUseCase,
) {
  const { enqueueSnackbar } = useSnackbar();
  const [feedback, setFeedback] = useState<string | undefined>();
  const [rating, setRating] = useState<number | undefined>();
  const [rateGiven, setRateGiven] = useState<boolean>(false);

  async function giveRatingToGame(gameId: string) {
    if (rating == undefined) return;
    showGlobalLoadingView(true);
    const response = await gameGiveRatingUseCase.invoke(gameId, {
      feedback,
      rate: rating,
    });
    showGlobalLoadingView(false);
    switch (response.responseState) {
      case State.Success:
        setRateGiven(true);
        break;
      case State.Fail:
      case State.Error:
        showSnackbar(response.error?.message);
        break;
    }
  }

  function showSnackbar(
    message: string | undefined,
    variant: "error" | "success" = "error",
  ) {
    if (message) enqueueSnackbar(message, { variant: variant });
  }
  return {
    rateGiven,
    rating,
    setRating,
    feedback,
    setFeedback,
    giveRatingToGame
  };
}
